import get from 'lodash/get'
import { nextTick } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import dashboardV5 from './dashboard-v5'
import kiosk from './kiosk'
import settingsV5 from './settings-v5'
import standalones from './standalones'

export const router = createRouter({
  linkExactActiveClass: 'exact-active',
  linkActiveClass: 'active',
  history: createWebHistory(),
  routes: [...settingsV5, ...dashboardV5, ...kiosk, ...standalones],
  scrollBehavior(to, _from, _savedPosition) {
    if (to.hash) {
      return new Promise((resolve, _reject) => {
        // without setTimeout, it will not scroll to the hash
        // the component is not yet rendered when this is called, delay 100ms
        setTimeout(() => {
          resolve({
            selector: to.hash,
            behavior: 'smooth',
          })
        }, 100)
      })
    }

    return { left: 0, top: 0 }
  },
})

router.beforeEach((to, from, next) => {
  if (to.matched.length > 0 && typeof to.meta.rolePermission !== 'undefined' && !Spark.roleHasPermission(to.meta.rolePermission)) {
    if (to.meta.alertNoPermission) {
      window.SwalTimer.fire({
        icon: 'error',
        title: 'No permission, please contact your admin.',
      })
      next(false)
    }
    else {
      location.href = Spark.router('web.pages.no-role-permission')
    }
  }
  else {
    next()
  }
})

router.afterEach((to, from) => {
  // Re-title only works for matched routes
  if (to.matched.length > 0) {
    nextTick(() => {
      if (to.meta.title) {
        document.title = `${to.meta.title} - ${import.meta.env.VITE_APP_NAME}`
      }
      else {
        document.title = import.meta.env.VITE_APP_NAME
      }

      const classNamesToAdd = to.meta.bodyClass
      if (classNamesToAdd) {
        classNamesToAdd.split(' ').forEach((className) => {
          if (className.trim()) {
            document.body.classList.add(className.trim())
          }
        })
      }
    })
  }

  const classNamesToRemove = get(from, 'meta.bodyClass')
  if (classNamesToRemove) {
    classNamesToRemove.split(' ').forEach((className) => {
      if (className.trim()) {
        document.body.classList.remove(className.trim())
      }
    })
  }
})

export default router
